import * as React from "react";
//#region types
//#endregion
//#region components
import { loginComponent } from ".";
import useLoginContext from "./context/useLoginContext";
import LoginLayout from "./loginLayout";
//#endregion

const Login: React.FC = (props) => {
  const { loginView } = useLoginContext();

  const LoginComponent = React.useMemo(() => loginComponent[loginView], [loginView]);

  return (
    <LoginLayout
      render={(displayType, isAuthenticated) => (
        <LoginComponent displayType={displayType} isAuthenticated={isAuthenticated} />
      )}
    />
  );
};

export default Login;
